/**
 * Convenience-wrapper for document.createElementNS('http://www.w3.org/2000/svg', ...)
 *
 * @param tag The element tag
 * @returns The newly-created SVG element
 */
export function createSvgElement<T extends keyof SVGElementTagNameMap>(tag: T): SVGElement {
  return document.createElementNS('http://www.w3.org/2000/svg', tag);
}
